export { useKnowledgeHubCourseV2 } from './use-knowledge-hub-course-v2';
